// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/index' //状态管理
import '@/styles/index.scss' // global css

import Router from 'vue-router'

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.config.productionTip = false

import axios from 'axios'
import qs from 'qs'
Vue.prototype.$qs = qs;
Vue.prototype.$axios = axios


// 是否展示菜单
Vue.prototype.$showMenu = false

// 更改标题
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

// 跳转后返回顶部
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
});


/* eslint-disable no-new */
new Vue({
  el: '#app',
  data: function () {
    return {
      picUrl: 'https://img.chezhency.com/Uploads/Home/OfficialWebsite/assets/' // 图片地址
    }
  },
  created() {
    sessionStorage.setItem("fristTimeIn", 1);
    this.MatchingSta()
  },
  methods: {
    // 切换pc和M (部分页面)
    MatchingSta() {
      let now = Number(sessionStorage.getItem("fristTimeIn")); //为1的时候才跳转
      let czClient = this._isMobile();

      if (czClient == null) {
        Vue.prototype.$pc = true
      } else {
        Vue.prototype.$pc = false
      }
      if (czClient == null) {
        if (now == 1 && this.$pc) {
          this.$router.replace("/");
          sessionStorage.setItem("fristTimeIn", 2);
        }
        sessionStorage.setItem("isM", false);
      } else {
        if (now == 1 && !this.$pc) {
          this.$router.replace('/Indexm');
          sessionStorage.setItem("fristTimeIn", 2);
        }
        sessionStorage.setItem("isM", true);
        (function (doc, win) {
          var docEl = doc.documentElement,
            resizeEvt =
            "orientationchange" in window ? "orientationchange" : "resize",
            recalc = function () {
              var clientWidth = docEl.clientWidth;
              if (!clientWidth) return;
              docEl.style.fontSize = 50 * (clientWidth / 375) + "px";
            };
          if (!doc.addEventListener) return;
          win.addEventListener(resizeEvt, recalc, false);
          doc.addEventListener("DOMContentLoaded", recalc, false);
        })(document, window);
      }
    },
    // 判断M端
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
  },
  router,
  components: {
    App
  },
  template: '<App/>',
  store,
})



// WEBPACK FOOTER //
// ./src/main.js